import { NodeDefinition } from "src/types/node.types";
import { createNodeDef } from "../nodes.helpers";
import { falsoOverwrites } from "./overwrites";
import { FalsoKey } from "src/types/falso.types";
import * as falso from "@ngneat/falso";

const RAND_FN_PATTERN = /^rand([A-Z][a-zA-Z]*)$/;

const randFn = Object.entries(falso).filter(
  (entry): entry is [string, () => unknown] => {
    const [key, value] = entry;
    return typeof value === "function" && RAND_FN_PATTERN.test(key);
  }
);

export const falsoDefaultNodeDefs: NodeDefinition<any, any>[] = randFn.map(
  ([fnName, fn]) => {
    const name = fnName.substring("rand".length);
    const overwrites =
      fnName in falsoOverwrites ? falsoOverwrites[fnName as FalsoKey] : {};

    return createNodeDef({
      type: fnName,
      displayName: name.replace(/([A-Z])/g, " $1").trim(),
      defaultName: name.replace(/^[A-Z]/, (s) => s.toLowerCase()),
      initialData: () => ({}),
      generate: async () => fn(),
      ...overwrites,
    });
  }
);
